import { Setting, SettingName } from 'core/types';
import { apiCall } from 'http/index';

export const getSettingByName = async (name: SettingName): Promise<Setting | null> =>
  apiCall({ method: 'get', url: 'settings', params: { name } });
